type SupportedResourceLinkType = 'videos' | 'blog';

export type { SupportedResourceLinkType };

export const linkToResourceCenter = ({
  slug,
  contentType,
}: {
  slug: string;
  contentType: SupportedResourceLinkType;
}) => {
  if (contentType === 'blog') {
    return `/en/blog/?f=${encodeURIComponent(slug)}`;
  } else {
    return `/en/resource-center/${contentType}/?f=${encodeURIComponent(slug)}`;
  }
};
